import React from 'react'

import cx from 'classnames'
import { isNil } from 'ramda'
import { Route, Switch } from 'react-router-dom'

import { Icon } from '@driftt/tide-icons'

import GetStartedCard from 'components/GetStartedCard'
import FindMyTeamEmailSent from 'layouts/FindMyTeam/FindMyTeamEmailSent'
import FindMyTeamVerify from 'layouts/FindMyTeam/FindMyTeamVerify'
import SignupCard from 'layouts/SignupCard'
import SignupChoiceCard from 'layouts/SignupChoiceCard'
import VerifyEmail from 'layouts/VerifyEmail'
import VerifyEmailError from 'layouts/VerifyEmailError'

import './style.css'

const LANGUAGES = [
  { text: 'Hello!', language: 'english' },
  { text: 'Hola!', language: 'spanish' },
  { text: 'Olá', language: 'portuguese' },
  { text: 'Hei!', language: 'norwegian' },
  { text: 'Привет', language: 'russian' },
  { text: 'नमस्ते', language: 'hindi' },
  { text: '你好', language: 'chinese' },
  { text: 'Halo', language: 'indonesian' },
]

const TouchlessStart = ({
  search,
  displayChatNumber,
  interactiveColor,
  onValueChange,
  loginUrl,
  flow,
  ...props
}) => {
  const shouldHideDriftIcon = props.location.pathname.includes('expired')
  return (
    <div className={'setup-container touchless-start-container'}>
      <div
        className={'touchless-start-background touchless-start-background-size'}
      />
      {!isNil(displayChatNumber) && (
        <div
          key={displayChatNumber}
          className={cx(
            'touchless-start-speech-button',
            LANGUAGES[displayChatNumber].language,
            { 'interactive-color': interactiveColor }
          )}
        >
          {LANGUAGES[displayChatNumber].text}
        </div>
      )}
      <div className="setup-container-fields touchless-start-fields">
        <div className="touchless-start-container-elements">
          {!shouldHideDriftIcon && (
            <div className="touchless-start-logo-container">
              <Icon
                className="touchless-start-drift-logo"
                name="drift-logo-round"
              />
            </div>
          )}
          <Switch>
            <Route path="/start/verify/expired" component={VerifyEmailError} />
            <Route path="/start/findTeam/verify" component={FindMyTeamVerify} />
            <Route
              path="/start/findTeam/sent"
              component={FindMyTeamEmailSent}
            />
            <Route
              path="/start/signup"
              render={() => <SignupCard onValueChange={onValueChange} />}
            />
            <Route path="/start/verify" component={VerifyEmail} />
            <Route path="/start/select" component={SignupChoiceCard} />
            <Route path="/start" component={GetStartedCard} />
          </Switch>
        </div>
        <p className="touchless-start-fields-link">
          Already have a Drift account?
          <a className="touchless-start-link" href={loginUrl}>
            Sign in
          </a>
        </p>
      </div>
    </div>
  )
}

export default TouchlessStart
